import React from "react";
import Checkbox from "antd/lib/checkbox";
import { ICheckboxProps } from "./interface";

import "./index.less";

const ZCheckbox: React.FC<ICheckboxProps> = ({
	checkboxOption,
	children,
	className = "",
	...rest
}) => {
	if (checkboxOption) {
		return checkboxOption instanceof Object ? (
			<Checkbox
				className={`z-checkbox ${className}`}
				defaultChecked={checkboxOption.value}
				value={checkboxOption.value}
				{...rest}
			>
				{checkboxOption.label}
			</Checkbox>
		) : (
			<Checkbox className={`z-checkbox ${className}`} {...rest}>
				{checkboxOption}
			</Checkbox>
		);
	}
	return (
		<Checkbox className={`z-checkbox ${className}`} {...rest}>
			{children}
		</Checkbox>
	);
};

export default ZCheckbox;
